import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import {
  type ITextInputProps,
  TextInput,
} from "src/shared/forms/inputs/TextInputNew";
import combineValidations from "src/shared/forms/validations/combineValidations";
import Email from "src/shared/forms/validations/Email";

export interface IEmailInputProps
  extends Omit<ITextInputProps, "regex" | "type" | "isNoTrailingSpace"> {}

export const EmailInput = ({ validators, ...rest }: IEmailInputProps) => {
  const validations = useMemo(
    () => combineValidations(Email, validators),
    [validators],
  );

  return (
    <TextInput
      label={<FormattedMessage id="form.email" />}
      {...rest}
      validators={validations}
    />
  );
};
